import vuetify from "@/main";
import MainDraftEditModal from "../billing/review/editDraft/MainDraftEditModal.vue";
import InvoicesSummaryModal from '../billing/review/InvoicesSummaryModal.vue';
import ExpenseEdit from '@/modules/expenses/ExpenseEdit.vue';
import timeEntryModal from '@/modules/time/timeEntryModal.vue';
import CreateChargeModal from '@/modules/fixedfees/components/CreateChargeModal.vue';
(function () {
  angular.module('leanlaw').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
    $stateProvider.state("reports", {
      url: "/reports",
      params: {
        returnRoute: null,
        returnParams: null,
        returnLabel: null,
        dateRange: null,
        dateRangeId: null
      },
      template: require('./reports.html'),
      controller: 'Report3Ctrl'
    }).state("reports.dashboard", {
      // ?report deep links straight into an advanced or custom report,
      // by dashboard tag or id — e.g. /reports/?report=arinvoiceaging
      url: "/?report",
      params: {
        report: {
          value: null,
          squash: true,
          dynamic: true
        }
      },
      views: {
        main: {
          template: require("./dashboard/views/main.html"),
          controller: "DashboardCtrl"
        }
      }
    }).state("reports.generic", {
      url: "/generic/:id/:clientId/:matterId/:userId/:matterTagId/:chargeId/",
      params: {
        id: undefined,
        clientId: undefined,
        matterId: undefined,
        userId: undefined,
        matterTagId: undefined,
        dateRangeId: undefined,
        returnRoute: undefined,
        returnParams: undefined,
        returnLabel: undefined
      },
      views: {
        '@': {
          template: require("./generic/views/generic.html"),
          controller: "GenericReportMainCtrl"
        }
      }
    }).state("reports.generic.edit", {
      url: "/edit",
      views: {
        'edit@reports.generic': vuetify(MainDraftEditModal)
      },
      params: {
        invoiceId: null,
        invoice: null,
        onlyViewInvoice: null
      }
    }).state("reports.upgrade", {
      url: "/upgrade",
      params: {
        openDialog: true
      },
      views: {
        main: {
          template: require("./dashboard/views/main.html"),
          controller: "DashboardCtrl"
        }
      }
    }).state('reports.generic.charges', {
      url: "/edit/charges/:chargeId",
      views: {
        edit: {
          ...vuetify(CreateChargeModal)
        }
      },
      params: {
        chargeId: null,
        groupId: null,
        ledes: false,
        type: null,
        // the report's selectDone() refreshes the row on return, so keep
        // the user here rather than sending them to the matter
        stayOnRoute: true
      }
    }).state('reports.generic.expenses', {
      url: "/edit/expenses/:chargeId",
      params: {
        method: 'ReportsGeneric'
      },
      views: {
        edit: {
          ...vuetify(ExpenseEdit)
        }
      },
      params: {
        expenseId: null,
        type: null,
        method: 'ReportsGeneric'
      }
    }).state('reports.generic.entry', {
      url: "/edit/time/:entryId",
      views: {
        'edit': {
          template: require('../time/views/edit.html'),
          controller: 'EntryEditCtrl'
        }
      },
      params: {
        entryId: null,
        type: null
      }
    }).state('reports.generic.entry2', {
      url: "/edit/time2/:entryId",
      views: {
        'edit': {
          ...vuetify(timeEntryModal)
        }
      },
      params: {
        entryId: null,
        type: null,
        adjustments: true
      }
    }).state("reports.client-summary", {
      url: "/client-summary/:clientId/:matterId?return&report",
      params: {
        matterId: null,
        clientId: null,
        report: null,
        backParams: null
      },
      views: {
        main: {
          template: require("./reports/client-summary/index.html"),
          controller: "SummaryIndexController"
        },
        // sidebar: {
        //     template: require("./reports/client-summary/sidebar.html"),
        //     controller: "SummaryIndexSidebarController"
        // },
        "overview@reports.client-summary": {
          template: require("./reports/client-summary/overview.html"),
          controller: "SummaryOverviewController"
        },
        "billable@reports.client-summary": {
          template: require("./reports/client-summary/billable.html"),
          controller: "SummaryBillableController"
        },
        "users@reports.client-summary": {
          template: require("./reports/client-summary/users.html"),
          controller: "SummaryUsersController"
        },
        "activity@reports.client-summary": {
          template: require("./reports/client-summary/activity.html"),
          controller: "SummaryActivityController"
        },
        "time@reports.client-summary": {
          template: require("./reports/client-summary/time.html"),
          controller: "SummaryTimeController"
        },
        "expenses@reports.client-summary": {
          template: require("./reports/client-summary/expenses.html"),
          controller: "SummaryExpensesController"
        },
        "charges@reports.client-summary": {
          template: require("./reports/client-summary/charges.html"),
          controller: "SummaryChargesController"
        },
        "transactions@reports.client-summary": {
          template: require("./reports/client-summary/transactions.html"),
          controller: "SummaryTransactionsController"
        }
      }
    }).state("reports.productivity-detail", {
      url: "/productivity-detail/:userId/:clientId/:matterId?return&report",
      views: {
        main: {
          template: require("./reports/productivity-detail/views/main.html"),
          controller: "ProductivityDetailCtrl"
        },
        sidebar: {
          template: require("./reports/productivity-detail/views/sidebar.html"),
          controller: "ProductivityDetailSidebarCtrl"
        }
      }
    }).state("reports.client-matter-billables", {
      url: "/client-matter-billables",
      views: {
        sidebar: {
          template: require("./reports/client-matter-billables/views/sidebar.html"),
          controller: "ClientMatterBillablesSidebarCtrl"
        },
        main: {
          template: require("./reports/client-matter-billables/views/main.html"),
          controller: "ClientMatterBillablesCtrl3"
        }
      }
    }).state("reports.my-productivity", {
      url: "/my-productivity",
      views: {
        sidebar: {
          template: require("./reports/my-productivity/views/sidebar.html"),
          controller: "MyProductivitySidebarCtrl"
        },
        main: {
          template: require("./reports/my-productivity/views/main.html"),
          controller: "MyProductivityCtrl"
        }
      }
    }).state("reports.client-matter-productivity", {
      url: "/client-matter-productivity/{userId}",
      views: {
        sidebar: {
          template: require("./reports/client-matter-productivity/views/sidebar.html"),
          controller: "ClientMatterProductivitySidebarCtrl"
        },
        main: {
          template: require("./reports/client-matter-productivity/views/main.html"),
          controller: "ClientMatterProductivityCtrl"
        }
      }
    }).state("reports.attorney-billable", {
      url: "/attorney-billable",
      views: {
        sidebar: {
          template: require("./reports/attorney-billable/views/sidebar.html"),
          controller: "AttorneyBillableSidebarCtrl"
        },
        main: {
          template: require("./reports/attorney-billable/views/main.html"),
          controller: "AttorneyBillableCtrl"
        }
      }
    }).state("reports.attorney-billable-detail", {
      url: "/attorney-billable-detail/:userId/?return&report",
      params: {
        userId: null,
        report: null
      },
      views: {
        main: {
          template: require("./reports/attorney-billable-detail/views/main.html"),
          controller: "AttorneyBillableDetailCtrl"
        },
        sidebar: {
          template: require("./reports/attorney-billable-detail/views/sidebar.html"),
          controller: "AttorneyBillableDetailSidebarCtrl"
        }
      }
    }).state("reports.contingency", {
      url: "/contingency",
      views: {
        sidebar: {
          template: require("./reports/contingency/views/sidebar.html"),
          controller: "ContingencyReportSidebarCtrl"
        },
        main: {
          template: require("./reports/contingency/views/main.html"),
          controller: "ContingencyReportCtrl"
        }
      }
    }).state("reports.receivables", {
      url: "/receivables",
      views: {
        sidebar: {
          template: require("./reports/receivables/views/sidebar.html"),
          controller: "ReceivablesReportSidebarCtrl"
        },
        main: {
          template: require("./reports/receivables/views/main.html"),
          controller: "ReceivablesReportCtrl"
        }
      }
    }).state("reports.my-receivables", {
      url: "/my-receivables",
      views: {
        sidebar: {
          template: require("./reports/my-receivables/views/sidebar.html"),
          controller: "MyReceivablesReportSidebarCtrl"
        },
        main: {
          template: require("./reports/my-receivables/views/main.html"),
          controller: "MyReceivablesReportCtrl"
        }
      }
    }).state("reports.receivables-invoices-list", {
      url: "/receivables-invoices-list/:clientId/:matterId",
      views: {
        sidebar: {
          template: require("./reports/receivables-invoices-list/views/sidebar.html"),
          controller: "ReceivablesInvoicesSidebarListCtr"
        },
        main: {
          template: require("./reports/receivables-invoices-list/views/main.html"),
          controller: "ReceivablesInvoicesListCtr"
        }
      }
    }).state("reports.receivables-invoices-list.edit", {
      url: "/edit",
      views: {
        'invoice@reports.receivables-invoices-list': vuetify(MainDraftEditModal)
      },
      params: {
        invoiceId: null,
        invoice: null,
        onlyViewInvoice: null
      }
    }).state("reports.my-receivables-invoices-list", {
      url: "/my-receivables-invoices-list/:clientId/:matterId",
      params: {
        reportType: null
      },
      views: {
        sidebar: {
          template: require("./reports/receivables-invoices-list/views/sidebar.html"),
          controller: "ReceivablesInvoicesSidebarListCtr"
        },
        main: {
          template: require("./reports/receivables-invoices-list/views/main.html"),
          controller: "ReceivablesInvoicesListCtr"
        }
      }
    }).state("reports.my-receivables-invoices-list.edit", {
      url: "/edit",
      views: {
        'invoice@reports.my-receivables-invoices-list': vuetify(MainDraftEditModal)
      },
      params: {
        invoiceId: null,
        invoice: null,
        onlyViewInvoice: null
      }
    }).state("reports.custom", {
      url: "/custom",
      views: {
        sidebar: {
          template: require("./reports/custom/views/sidebar.html"),
          controller: "CustomReportSidebarCtrl"
        },
        main: {
          template: require("./reports/custom/views/main.html"),
          controller: "CustomReportCtrl"
        }
      }
    }).state("reports.custom-detail", {
      url: "/custom-detail/{userId}",
      params: {
        userId: null
      },
      views: {
        sidebar: {
          template: require("./reports/custom-detail/views/sidebar.html"),
          controller: "CustomDetailReportSidebarCtrl"
        },
        main: {
          template: require("./reports/custom-detail/views/main.html"),
          controller: "CustomDetailReportCtrl"
        }
      }
    }).state("reports.contingency-detail", {
      url: "/contingency-detail/:clientId/:matterId",
      views: {
        sidebar: {
          template: require("./reports/contingency-detail/views/sidebar.html"),
          controller: "ContingencyReportDetailSidebarCtrl"
        },
        main: {
          template: require("./reports/contingency-detail/views/main.html"),
          controller: "ContingencyReportDetailCtrl"
        }
      }
    }).state("reports.contingency-expense", {
      url: "/contingency-expense",
      views: {
        sidebar: {
          template: require("./reports/contingency-expense/views/sidebar.html"),
          controller: "ContingencyExpenseReportSidebarCtrl"
        },
        main: {
          template: require("./reports/contingency-expense/views/main.html"),
          controller: "ContingencyExpenseReportCtrl"
        }
      }
    }).state("reports.practice-area-billables", {
      url: "/practice-area-billables",
      views: {
        sidebar: {
          template: require("./reports/practice-area-billables/views/sidebar.html"),
          controller: "MatterTagBillablesSidebarCtrl"
        },
        main: {
          template: require("./reports/practice-area-billables/views/main.html"),
          controller: "MatterTagBillablesCtrl"
        }
      }
    }).state("reports.practice-area-billables-detail", {
      url: "/practice-area-billables-detail/:matterTag",
      params: {
        matterTag: null
      },
      views: {
        sidebar: {
          template: require("./reports/practice-area-billables-detail/views/sidebar.html"),
          controller: "MatterTagBillablesDetailSidebarCtrl"
        },
        main: {
          template: require("./reports/practice-area-billables-detail/views/main.html"),
          controller: "MatterTagBillablesDetailCtrl"
        }
      }
    }).state("reports.client-matter-revenue", {
      url: "/client-matter-revenue",
      views: {
        sidebar: {
          template: require("./reports/client-matter-revenue/views/sidebar.html"),
          controller: "ClientMatterRevenueSidebarCtrl"
        },
        main: {
          template: require("./reports/client-matter-revenue/views/main.html"),
          controller: "ClientMatterRevenueCtrl"
        }
      }
    }).state("reports.client-matter-customflag", {
      url: "/client-matter-customflag",
      views: {
        sidebar: {
          template: require("./reports/client-matter-customflag/views/sidebar.html"),
          controller: "ClientMatterCustomFlagSidebarCtrl"
        },
        main: {
          template: require("./reports/client-matter-customflag/views/main.html"),
          controller: "ClientMatterCustomFlagCtrl"
        }
      }
    }).state("reports.trust", {
      url: "/trust",
      views: {
        sidebar: {
          template: require("./reports/trust/views/sidebar.html"),
          controller: "TrustReportSidebarCtrl"
        },
        main: {
          template: require("./reports/trust/views/main.html"),
          controller: "TrustReportCtrl"
        }
      }
    }).state("reports.trust-detail", {
      url: "/trust-detail/:clientId/:matterId",
      params: {
        return: "reports.trust",
        backParams: {}
      },
      views: {
        sidebar: {
          template: require("./reports/trust-detail/views/sidebar.html"),
          controller: "TrustDetailSidebarCtrl"
        },
        main: {
          template: require("./reports/trust-detail/views/main.html"),
          controller: "TrustDetailCtrl"
        }
      }
    }).state("reports.client-matter-revenue-invoices", {
      url: "/client-matter-revenue-invoices/:clientId/:matterId",
      views: {
        sidebar: {
          template: require("./reports/client-matter-revenue-invoices/views/sidebar.html"),
          controller: "ClientMatterRevenueInvoicesSidebarCtrl"
        },
        main: {
          template: require("./reports/client-matter-revenue-invoices/views/main.html"),
          controller: "ClientMatterRevenueInvoicesCtrl"
        }
      }
    }).state("reports.client-matter-revenue-invoices.edit", {
      url: "/edit",
      views: {
        'invoice@reports.client-matter-revenue-invoices': vuetify(MainDraftEditModal)
      },
      params: {
        invoiceId: null,
        invoice: null,
        onlyViewInvoice: null
      }
    }).state("reports.practice-area-revenue", {
      url: "/practice-area-revenue",
      views: {
        sidebar: {
          template: require("./reports/practice-area-revenue/views/sidebar.html"),
          controller: "MatterTagRevenueSidebarCtrl"
        },
        main: {
          template: require("./reports/practice-area-revenue/views/main.html"),
          controller: "MatterTagRevenueCtrl"
        }
      }
    }).state("reports.originating-attorney", {
      url: "/originating-attorney",
      views: {
        sidebar: {
          template: require("./reports/originating-attorney/views/sidebar.html"),
          controller: "OriginatingAttorneySidebarCtrl"
        },
        main: {
          template: require("./reports/originating-attorney/views/main.html"),
          controller: "OriginatingAttorneyCtrl"
        }
      }
    }).state("reports.originating-attorney-billed", {
      url: "/originating-attorney-billed",
      views: {
        sidebar: {
          template: require("./reports/originating-attorney-billed/views/sidebar.html"),
          controller: "OriginatingAttorneyBilledSidebarCtrl"
        },
        main: {
          template: require("./reports/originating-attorney-billed/views/main.html"),
          controller: "OriginatingAttorneyBilledCtrl"
        }
      }
    }).state("reports.originating-attorney-billed-detail", {
      url: "/originating-attorney-billed-detail/:id",
      views: {
        sidebar: {
          template: require("./reports/originating-attorney-billed-detail/views/sidebar.html"),
          controller: "OriginatingAttorneyBilledDetailSidebarCtrl"
        },
        main: {
          template: require("./reports/originating-attorney-billed-detail/views/main.html"),
          controller: "OriginatingAttorneyBilledDetailCtrl"
        }
      }
    }).state("reports.originating-attorney-detail", {
      url: "/originating-attorney-detail/:id",
      views: {
        sidebar: {
          template: require("./reports/originating-attorney-detail/views/sidebar.html"),
          controller: "OriginatingAttorneyDetailSidebarCtrl"
        },
        main: {
          template: require("./reports/originating-attorney-detail/views/main.html"),
          controller: "OriginatingAttorneyDetailCtrl"
        }
      }
    }).state("reports.originating-attorney-invoices", {
      url: "/originating-attorney-invoices/:accountId/:clientId/:matterId",
      views: {
        sidebar: {
          template: require("./reports/originating-attorney-invoices/views/sidebar.html"),
          controller: "OriginatingAttorneyInvoicesSidebarCtrl"
        },
        main: {
          template: require("./reports/originating-attorney-invoices/views/main.html"),
          controller: "OriginatingAttorneyInvoicesCtrl"
        }
      }
    }).state("reports.originating-attorney-invoices.edit", {
      url: "/edit",
      views: {
        'invoice@reports.originating-attorney-invoices': vuetify(MainDraftEditModal)
      },
      params: {
        invoiceId: null,
        invoice: null,
        onlyViewInvoice: null
      }
    }).state("reports.practice-area-revenue-detail", {
      url: "/practice-area-revenue-detail/:matterTag",
      params: {
        matterTag: null
      },
      views: {
        sidebar: {
          template: require("./reports/practice-area-revenue-detail/views/sidebar.html"),
          controller: "MatterTagRevenueDetailSidebarCtrl"
        },
        main: {
          template: require("./reports/practice-area-revenue-detail/views/main.html"),
          controller: "MatterTagRevenueDetailCtrl"
        }
      }
    }).state("reports.practice-area-revenue-invoices", {
      url: "/practice-area-revenue-invoices/:matterTag/:clientId/:matterId",
      params: {
        matterTag: null
      },
      views: {
        sidebar: {
          template: require("./reports/practice-area-revenue-invoices/views/sidebar.html"),
          controller: "MatterTagRevenueInvoicesSidebarCtrl"
        },
        main: {
          template: require("./reports/practice-area-revenue-invoices/views/main.html"),
          controller: "MatterTagRevenueInvoicesCtrl"
        }
      }
    }).state("reports.practice-area-revenue-invoices.edit", {
      url: "/edit",
      views: {
        'invoice@reports.practice-area-revenue-invoices': vuetify(MainDraftEditModal)
      },
      params: {
        invoiceId: null,
        invoice: null,
        onlyViewInvoice: null
      }
    }).state("reports.timekeeper-productivity", {
      url: "/timekeeper-productivity/{clientId}/{matterId}",
      views: {
        sidebar: {
          template: require("./reports/timekeeper-productivity/views/sidebar.html"),
          controller: "TimekeeperProductivitySidebarCtrl"
        },
        main: {
          template: require("./reports/timekeeper-productivity/views/main.html"),
          controller: "TimekeeperProductivityCtrl"
        }
      }
    }).state("reports.attorney-revenue", {
      url: "/attorney-revenue",
      views: {
        sidebar: {
          template: require("./reports/attorney-revenue/views/sidebar.html"),
          controller: "AttorneyRevenueSidebarCtrl"
        },
        main: {
          template: require("./reports/attorney-revenue/views/main.html"),
          controller: "AttorneyRevenueCtrl"
        }
      }
    }).state("reports.attorney-my-revenue", {
      url: "/attorney-my-revenue",
      views: {
        sidebar: {
          template: require("./reports/attorney-my-revenue/views/sidebar.html"),
          controller: "AttorneyMyRevenueSidebarCtrl"
        },
        main: {
          template: require("./reports/attorney-my-revenue/views/main.html"),
          controller: "AttorneyMyRevenueCtrl"
        }
      }
    }).state("reports.attorney-revenue-detail", {
      url: "/attorney-revenue-detail/{id}",
      views: {
        sidebar: {
          template: require("./reports/attorney-revenue-detail/views/sidebar.html"),
          controller: "AttorneyRevenueDetailSidebarCtrl"
        },
        main: {
          template: require("./reports/attorney-revenue-detail/views/main.html"),
          controller: "AttorneyRevenueDetailCtrl"
        }
      }
    }).state("reports.attorney-revenue-invoices", {
      url: "/attorney-revenue-invoices/:accountId/:clientId/:matterId",
      views: {
        sidebar: {
          template: require("./reports/attorney-revenue-invoices/views/sidebar.html"),
          controller: "AttorneyRevenueInvoicesSidebarCtrl"
        },
        main: {
          template: require("./reports/attorney-revenue-invoices/views/main.html"),
          controller: "AttorneyRevenueInvoicesCtrl"
        }
      }
    }).state(`reports.attorney-revenue-invoices.invoiceSummary`, {
      url: "/invoiceSummary/{id}",
      views: {
        'invoice@reports.attorney-revenue-invoices': vuetify(InvoicesSummaryModal)
      }
    }).state(`reports.attorney-revenue-invoices.edit`, {
      url: "/edit",
      views: {
        'invoice@reports.attorney-revenue-invoices': vuetify(MainDraftEditModal)
      },
      params: {
        invoiceId: null,
        invoice: null,
        onlyViewInvoice: null
      }
    }).state("reports.attorney-revenue-unallocated", {
      url: "/attorney-revenue-unallocated",
      views: {
        sidebar: {
          template: require("./reports/attorney-revenue-unallocated/views/sidebar.html"),
          controller: "AttorneyRevenueUnallocatedSidebarCtrl"
        },
        main: {
          template: require("./reports/attorney-revenue-unallocated/views/main.html"),
          controller: "AttorneyRevenueUnallocatedCtrl"
        }
      }
    }).state("reports.fixed-fee-profitability", {
      url: "/fixed-fee-profitability",
      views: {
        sidebar: {
          template: require("./reports/fixed-fee-profitability/views/sidebar.html"),
          controller: "FixedFeeProfitabilitySidebarCtrl"
        },
        main: {
          template: require("./reports/fixed-fee-profitability/views/main.html"),
          controller: "FixedFeeProfitabilityCtrl"
        }
      }
    }).state("reports.ready-to-bill", {
      url: "/ready-to-bill",
      views: {
        sidebar: {
          template: require("./reports/ready-to-bill/views/sidebar.html"),
          controller: "ReadyToBillSidebarCtrl"
        },
        main: {
          template: require("./reports/ready-to-bill/views/main.html"),
          controller: "ReadyToBillCtrl"
        }
      }
    }).state("reports.matter-rates", {
      url: "/matter-rates",
      views: {
        sidebar: {
          template: require("./reports/matter-rates/views/sidebar.html"),
          controller: "MatterRatesSidebarCtrl"
        },
        main: {
          template: require("./reports/matter-rates/views/main.html"),
          controller: "MatterRatesCtrl"
        }
      }
    }).state("reports.matter-activity", {
      url: "/matter-activity",
      views: {
        sidebar: {
          template: require("./reports/matter-activity/views/sidebar.html"),
          controller: "MatterActivitySidebarCtrl"
        },
        main: {
          template: require("./reports/matter-activity/views/main.html"),
          controller: "MatterActivityCtrl"
        }
      }
    }).state("reports.period-reports", {
      url: "/period-reports",
      views: {
        sidebar: {
          template: require("./reports/period-reports/views/sidebar.html"),
          controller: "PeriodReportsSidebarCtrl"
        },
        main: {
          template: require("./reports/period-reports/views/main.html"),
          controller: "PeriodReportsCtrl3"
        }
      }
    }).state("reports.client-contact", {
      url: "/client-contact",
      views: {
        sidebar: {
          template: require("./reports/client-contact/views/sidebar.html"),
          controller: "ClientContactSidebarCtrl"
        },
        main: {
          template: require("./reports/client-contact/views/main.html"),
          controller: "ClientContactCtrl"
        }
      }
    }).state("reports.codes-billables", {
      url: "/codes-billables",
      views: {
        sidebar: {
          template: require("./reports/codes-billables/views/sidebar.html"),
          controller: "CodesBillablesSidebarCtrl"
        },
        main: {
          template: require("./reports/codes-billables/views/main.html"),
          controller: "CodesBillablesCtrl"
        }
      }
    }).state("reports.codes-billables-detail", {
      url: "/codes-billables-detail/:code",
      params: {
        code: null
      },
      views: {
        sidebar: {
          template: require("./reports/codes-billables-detail/views/sidebar.html"),
          controller: "CodesBillablesDetailSidebarCtrl"
        },
        main: {
          template: require("./reports/codes-billables-detail/views/main.html"),
          controller: "CodesBillablesDetailCtrl"
        }
      }
    });
  }]);
})();